module.exports = __webpack_public_path__ + "graphics/05.ckh.a458d3cca069002a80fedf641136689e.png";